/* ==========================================================================
   BOSSVI · Ficha de producto — comportamiento
   --------------------------------------------------------------------------
   Va con snippets/bossvi-pro.liquid y solo se carga en la plantilla
   product.bossvi. NO toca la fontanería del carrito: el <variant-picker> de
   Horizon sigue siendo el que manda, aquí solo se le añade información encima.

   Hace tres cosas:
     1. Mete el precio dentro de cada botón de medida y esconde las filas de
        opción que solo tienen un valor (no eligen nada, solo hacen ruido).
        Desde el 16 oct, además: pone «5 medidas · desde 76,80 €» a la derecha
        del rótulo de la opción (TAMAÑO / COLOR) y un punto con el color en
        las tarjetas de la opción «Color».
        Desde el 5 oct, además: si se toca una medida o un color que no
        existe con lo que ya está marcado (Rosa inglesa: la de 54 cm solo
        se hace en Malva), salta sola a la combinación que sí existe, en vez
        de dejar la ficha sin precio. Lo agotado de verdad dice «Agotado».
     2. Dibuja el comparador de tamaño a partir de la altura de la variante.
     3. Calcula la fecha concreta de entrega (hora de corte, taller y reparto; ver
        el comentario de fechaEntrega y los data-* del aviso en bossvi-pro.liquid).

   La barra de compra fija NO se monta aquí: Horizon ya trae la suya
   (<sticky-add-to-cart>, ajuste «enable_sticky_add_to_cart» de la sección),
   con foto, precio y un botón que clica el real. Montar otra sería poner
   dos barras una encima de otra.

   OJO: Horizon REPINTA el bloque de la ficha cada vez que cambia la variante,
   así que todo lo que añadimos se pierde y hay que volver a ponerlo. De ahí el
   MutationObserver. Es el mismo patrón que el del cajón del carrito.
   ========================================================================== */
(function () {
  'use strict';

  /* Este fichero se puede ejecutar más de una vez: va dentro de un bloque
     custom-liquid y el tema lo repinta al cambiar de variante. Si ya hay una
     instancia viva, solo se le pide que repase y se sale. */
  if (window.bvPro && typeof window.bvPro.repasar === 'function') {
    window.bvPro.repasar();
    return;
  }

  var datos = null;
  try {
    var caja = document.getElementById('bv-pro-datos');
    datos = caja ? JSON.parse(caja.textContent) : null;
  } catch (e) {
    datos = null;
  }
  if (!datos || !datos.variantes || !datos.variantes.length) { return; }

  var porId = {};
  for (var i = 0; i < datos.variantes.length; i++) {
    porId[String(datos.variantes[i].id)] = datos.variantes[i];
  }

  function euros(centimos) {
    var n = (centimos / 100).toFixed(2).replace('.', ',');
    return n + ' €';
  }

  /* ---------------------------------------------------------------- */
  /* 1 · El selector                                                   */
  /* ---------------------------------------------------------------- */

  /* Con dos opciones, el radio no siempre trae data-variant-id, así que la
     variante se busca combinando lo que hay marcado ahora con este valor. */
  function variantePara(indiceOpcion, valor) {
    var marcados = seleccionActual();
    marcados[indiceOpcion] = valor;
    for (var j = 0; j < datos.variantes.length; j++) {
      var v = datos.variantes[j];
      var vale = true;
      for (var k = 0; k < marcados.length; k++) {
        if (marcados[k] !== null && v.opciones[k] !== marcados[k]) { vale = false; break; }
      }
      if (vale) { return v; }
    }
    return null;
  }

  /* La variante que encaja exactamente con lo marcado (null si no existe). */
  function varianteExacta(marcados) {
    for (var j = 0; j < datos.variantes.length; j++) {
      var v = datos.variantes[j];
      var vale = true;
      for (var k = 0; k < marcados.length; k++) {
        if (marcados[k] !== null && v.opciones[k] !== marcados[k]) { vale = false; break; }
      }
      if (vale) { return v; }
    }
    return null;
  }

  /* Cuando la combinación no existe: la variante con ese valor que mejor
     encaja. Primero las que se pueden comprar; después, la que respeta más
     de lo que ya estaba marcado. */
  function mejorVariante(indiceOpcion, valor, marcados) {
    var mejor = null;
    var puntos = -1;
    for (var j = 0; j < datos.variantes.length; j++) {
      var v = datos.variantes[j];
      if (v.opciones[indiceOpcion] !== valor) { continue; }
      var p = v.disponible ? 100 : 0;
      for (var k = 0; k < marcados.length; k++) {
        if (k !== indiceOpcion && marcados[k] !== null && v.opciones[k] === marcados[k]) { p += 1; }
      }
      if (p > puntos) { puntos = p; mejor = v; }
    }
    return mejor;
  }

  function seleccionActual() {
    var fuera = [];
    var picker = pickerFicha();
    var campos = picker ? picker.querySelectorAll('fieldset.variant-option') : [];
    for (var i = 0; i < campos.length; i++) {
      /* Primero lo que está marcado de verdad; el atributo del tema solo como
         respaldo, porque se actualiza más tarde que el propio radio. */
      var marcado = campos[i].querySelector('input[type="radio"]:checked') ||
        campos[i].querySelector('input[type="radio"][data-current-checked="true"]');
      fuera.push(marcado ? marcado.value : null);
    }
    return fuera;
  }

  /* El selector de la ficha, no el de una tarjeta de «también te puede
     gustar» ni el de un cajón rápido: primero el que está en la columna de
     detalles, y si no, el que el tema marca como el del producto de la página. */
  function pickerFicha() {
    return document.querySelector('.product-details variant-picker') ||
      document.querySelector('variant-picker[data-template-product-match="true"]') ||
      document.querySelector('variant-picker');
  }

  /* 16 oct: «5 medidas · desde 76,80 €» (lo escribe Liquid en un <p hidden data-bv-meta>)
     se coloca a la derecha del rótulo de la primera opción que de verdad se elige
     (TAMAÑO, o COLOR si solo hay colores). Antes flotaba suelto debajo del título. */
  function metaEnRotulo(campo) {
    var fuente = document.querySelector('.product-details [data-bv-meta]') || document.querySelector('[data-bv-meta]');
    var legend = campo.querySelector('legend');
    if (!fuente || !legend) { return; }
    var txt = (fuente.textContent || '').replace(/\s+/g, ' ').trim();
    if (!txt) { return; }
    var span = legend.querySelector('.bv-legend-meta');
    if (!span) {
      span = document.createElement('span');
      span.className = 'bv-legend-meta';
      legend.appendChild(span);
    }
    if (span.textContent !== txt) { span.textContent = txt; }
  }

  /* 16 oct: punto con el color de cada acabado, en las tarjetas de la opción «Color».
     El color sale del nombre («Azul intenso», «Rojo 91cm»…); si no se reconoce, no se
     pinta nada: mejor sin punto que con un punto que mienta. Los mezclados llevan un
     degradado de tres tonos. */
  var COLORES = {
    'blanco': '#F6F3EC', 'blanca': '#F6F3EC', 'crema': '#EFE4CB', 'champán': '#EFE4CB', 'marfil': '#EFE4CB',
    'beige': '#D9C7A7', 'arena': '#D9C7A7', 'amarillo claro': '#F3E69A', 'amarillo': '#E9C84B', 'mostaza': '#D4A72C',
    'ámbar': '#D29A3A', 'ambar': '#D29A3A', 'dorado': '#D29A3A', 'oro': '#D29A3A', 'naranja': '#E07A3C',
    'salmón': '#EE9B7E', 'salmon': '#EE9B7E', 'melocotón': '#EE9B7E', 'coral': '#E8766A', 'terracota': '#B85C38',
    'rosa claro': '#F3C1CF', 'rosa palo': '#F3C1CF', 'rosa': '#E48FB0', 'fucsia': '#D63A8A', 'cyclamen': '#C94C8C',
    'ciclamen': '#C94C8C', 'magenta': '#C94C8C', 'cereza': '#9E1B32', 'rojo': '#C2282E', 'roja': '#C2282E',
    'burdeos': '#6E1B2A', 'granate': '#6E1B2A', 'vino': '#6E1B2A', 'malva': '#B58BB8', 'lila': '#C7A6D8',
    'lavanda': '#9B8BC4', 'violeta': '#7B4FA3', 'morado': '#5E2C7A', 'púrpura': '#5E2C7A', 'berenjena': '#4B2244',
    'azul intenso': '#2F4D8C', 'azul oscuro': '#2F4D8C', 'azul marino': '#2F4D8C', 'azul claro': '#A9C4E4',
    'celeste': '#A9C4E4', 'azul': '#4F76B8', 'verde claro': '#9DBA7E', 'verde oliva': '#7B7A3C', 'oliva': '#7B7A3C',
    'verde gris': '#8A9A86', 'verde grisáceo': '#8A9A86', 'gris verde': '#8A9A86', 'verde oscuro': '#3F5A3A',
    'verde': '#5F7F4A', 'natural': '#5F7F4A', 'marrón': '#6B4A2B', 'marron': '#6B4A2B', 'chocolate': '#6B4A2B',
    'gris': '#9A9A96', 'negro': '#1A1A1A', 'plateado': '#B8BCC0', 'plata': '#B8BCC0',
    'otoño': 'conic-gradient(#8A9A5B 0 34%, #B6563A 34% 67%, #D08A6A 67%)',
    'otono': 'conic-gradient(#8A9A5B 0 34%, #B6563A 34% 67%, #D08A6A 67%)',
    'mixturado': 'conic-gradient(#C97B9A 0 34%, #8FA37E 34% 67%, #D9B46A 67%)',
    'mixto': 'conic-gradient(#C97B9A 0 34%, #8FA37E 34% 67%, #D9B46A 67%)',
    'multicolor': 'conic-gradient(#C97B9A 0 34%, #8FA37E 34% 67%, #D9B46A 67%)',
    'variegata': 'conic-gradient(#C97B9A 0 34%, #8FA37E 34% 67%, #D9B46A 67%)',
    'verde rosa': 'conic-gradient(#8FA37E 0 50%, #E48FB0 50%)',
    /* 26 oct (Navidad diseño): los colores de Navidad que faltaban */
    'grisáceo': '#9AA39B', 'grisacea': '#9AA39B', 'grisácea': '#9AA39B', 'gris azulado': '#7F8F93', 'gris verdoso': '#8A9A86',
    'burdeos y dorado': 'conic-gradient(#6E1B2A 0 50%, #D29A3A 50%)',
    'rojo y dorado': 'conic-gradient(#C2282E 0 50%, #D29A3A 50%)',
    'verde y rojo': 'conic-gradient(#3F5A3A 0 50%, #C2282E 50%)',
    'luz cálida': '#F3D27A', 'luz calida': '#F3D27A', 'blanco cálido': '#F3D27A',
    'cobre': '#B5653A', 'bronce': '#8C6A3F', 'nieve': '#F6F3EC', 'escarcha': '#DDE6E8', 'mimbre': '#C9B48C'
  };

  function colorDe(valor) {
    var n = String(valor || '').toLowerCase().replace(/\d+\s*cm/g, '').replace(/[-\/]/g, ' ').replace(/\s+/g, ' ').trim();
    if (COLORES[n]) { return COLORES[n]; }
    /* 26 oct: si el nombre entero no está («Almendro color rosa»), vale la primera palabra o pareja de palabras
       que sí sea un color; «y» entre dos colores conocidos dibuja medio punto de cada uno. */
    var partes = n.split(' y ');
    if (partes.length === 2 && COLORES[partes[0]] && COLORES[partes[1]] && COLORES[partes[0]].indexOf('(') < 0 && COLORES[partes[1]].indexOf('(') < 0) {
      return 'conic-gradient(' + COLORES[partes[0]] + ' 0 50%, ' + COLORES[partes[1]] + ' 50%)';
    }
    var w = n.split(' ');
    for (var i = 0; i < w.length; i++) {
      if (i + 1 < w.length && COLORES[w[i] + ' ' + w[i + 1]]) { return COLORES[w[i] + ' ' + w[i + 1]]; }
    }
    for (var k = 0; k < w.length; k++) {
      if (COLORES[w[k]]) { return COLORES[w[k]]; }
    }
    return '';
  }

  function esOpcionColor(campo) {
    var legend = campo.querySelector('legend');
    if (!legend) { return false; }
    var t = '';
    for (var i = 0; i < legend.childNodes.length; i++) {
      if (legend.childNodes[i].nodeType === 3) { t += legend.childNodes[i].textContent; }
    }
    t = t.trim().toLowerCase();
    return t === 'color' || t === 'colour' || t === 'acabado';
  }

  function ponerPunto(et, input) {
    if (et.querySelector('.bv-punto')) { return; }
    var c = colorDe(input.value);
    if (!c) { return; }
    var punto = document.createElement('span');
    punto.className = 'bv-punto';
    punto.setAttribute('aria-hidden', 'true');
    punto.style.setProperty('--bv-c', c);
    var texto = et.querySelector('.variant-option__button-label__text');
    if (texto) { et.insertBefore(punto, texto); } else { et.appendChild(punto); }
  }

  function mejorarSelector() {
    var picker = pickerFicha();
    if (!picker) { return; }
    picker.classList.add('bv-picker');

    var campos = picker.querySelectorAll('fieldset.variant-option');
    var metaPuesta = false;
    for (var i = 0; i < campos.length; i++) {
      var campo = campos[i];
      var etiquetas = campo.querySelectorAll('label.variant-option__button-label');

      /* Una opción con un solo valor no es una elección: fuera. */
      if (etiquetas.length < 2) {
        campo.classList.add('bv-opcion-muda');
        continue;
      }
      campo.classList.remove('bv-opcion-muda');
      if (!metaPuesta) { metaEnRotulo(campo); metaPuesta = true; }
      var esColor = esOpcionColor(campo);

      for (var j = 0; j < etiquetas.length; j++) {
        var et = etiquetas[j];
        var input = et.querySelector('input[type="radio"]');
        if (!input) { continue; }
        if (esColor) { ponerPunto(et, input); }

        var v = null;
        var id = input.getAttribute('data-variant-id');
        if (id && porId[id]) {
          v = porId[id];
        } else {
          v = variantePara(i, input.value);
        }

        /* Si con lo marcado esa combinación no existe, el botón enseña la
           combinación a la que saltará al tocarlo (y no se ve tachado). */
        var salta = false;
        if (!v) {
          v = mejorVariante(i, input.value, seleccionActual());
          salta = !!v;
        }
        var agotada = v ? !v.disponible : input.getAttribute('data-option-available') === 'false';
        if (agotada) {
          et.classList.add('bv-agotada');
        } else {
          et.classList.remove('bv-agotada');
        }
        if (salta && !agotada) {
          et.classList.add('bv-salta');
        } else {
          et.classList.remove('bv-salta');
        }

        if (!v) { continue; }

        var puesto = et.querySelector('.bv-precio-op');
        if (!puesto) {
          puesto = document.createElement('span');
          puesto.className = 'bv-precio-op';
          et.appendChild(puesto);
        }
        var texto = agotada ? 'Agotado' : euros(v.precio);
        if (puesto.textContent !== texto) { puesto.textContent = texto; }
      }
    }
  }

  /* Se toca una opción que no casa con lo marcado: ANTES de que el tema pida
     la variante (este aviso va en la fase de captura del documento, que
     llega antes que el del selector), se marcan las otras opciones de la
     combinación que sí existe. Así el tema ya pide una variante real y la
     ficha nunca se queda sin precio. */
  function corregirCombinacion(e) {
    var input = e.target;
    if (!input || input.type !== 'radio' || !input.checked) { return; }
    var picker = pickerFicha();
    if (!picker || !picker.contains(input)) { return; }
    var campos = picker.querySelectorAll('fieldset.variant-option');
    if (campos.length < 2) { return; }
    var indice = -1;
    for (var i = 0; i < campos.length; i++) {
      if (campos[i].contains(input)) { indice = i; break; }
    }
    if (indice < 0) { return; }

    var marcados = seleccionActual();
    marcados[indice] = input.value;
    if (varianteExacta(marcados)) { return; }
    var v = mejorVariante(indice, input.value, marcados);
    if (!v) { return; }

    for (var k = 0; k < campos.length; k++) {
      if (k === indice) { continue; }
      var radios = campos[k].querySelectorAll('input[type="radio"]');
      for (var r = 0; r < radios.length; r++) {
        if (radios[r].value !== v.opciones[k] || radios[r].checked) { continue; }
        try {
          if (typeof picker.updateSelectedOption === 'function') {
            picker.updateSelectedOption(radios[r]);
          } else {
            radios[r].checked = true;
          }
        } catch (err) {
          radios[r].checked = true;
        }
      }
    }

    /* El tema quita ?variant= de la dirección cuando la opción tocada no
       tenía variante propia: se vuelve a poner la buena. */
    setTimeout(function () {
      try {
        var url = new URL(window.location.href);
        if (url.searchParams.get('variant') !== String(v.id)) {
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
        }
      } catch (err) { /* nada */ }
    }, 150);
  }

  /* ---------------------------------------------------------------- */
  /* 2 · El comparador de tamaño                                       */
  /* ---------------------------------------------------------------- */

  /* El lienzo es el viewBox del SVG del snippet: 340 × 196.
     SUELO es la raya del suelo, así que por encima solo hay SUELO píxeles de
     sitio para dibujar. TOPE es la altura en píxeles de lo más alto de la
     escala, y por eso TIENE QUE salir de SUELO y no ser un número suelto:
     antes era 190 con SUELO en 168, así que lo más alto se salía 22 px por
     arriba y el SVG lo recortaba (recorta todo lo que asoma del viewBox).
     En fichas con varias medidas no cantaba, porque la referencia era la
     variante más alta y la persona quedaba pequeña; pero en una ficha de una
     sola medida por debajo de 170 cm la referencia baja a la propia persona,
     que pasa a ser lo más alto del dibujo, y se le cortaba la cabeza.
     AIRE deja además un respiro arriba para el grosor del trazo de las hojas,
     que van con una curva que sobresale un poco de su alto teórico. */
  var SUELO = 168;
  var AIRE = 16;
  var TOPE = SUELO - AIRE;

  function dibujo(cm, maxCm, nombre) {
    /* La referencia de la escala es lo más alto que se va a dibujar: la
       planta más alta de la ficha o la persona, lo que mida más. */
    var ref = Math.max(maxCm || 0, cm || 0, 170);
    var escala = TOPE / ref;
    var hP = cm * escala;
    var hH = 170 * escala;
    var xP = 92;
    var xH = 250;
    var s = '';

    s += '<line x1="10" y1="' + SUELO + '" x2="330" y2="' + SUELO + '" stroke="currentColor" stroke-width="1" opacity=".28"/>';

    /* Persona de 170 cm: cabeza, torso y piernas, sin pretender más */
    var rC = hH * 0.052;
    var yC = SUELO - hH + rC;
    var yHom = SUELO - hH * 0.82;
    var yCad = SUELO - hH * 0.50;
    var aHom = hH * 0.115, aCad = hH * 0.082, aPie = hH * 0.045;
    s += '<g opacity=".28" fill="currentColor">';
    s += '<circle cx="' + xH + '" cy="' + yC + '" r="' + rC.toFixed(1) + '"/>';
    s += '<rect x="' + (xH - hH * 0.0175) + '" y="' + (yC + rC) + '" width="' + (hH * 0.035) + '" height="' + (yHom - yC - rC) + '"/>';
    s += '<path d="M' + (xH - aHom) + ' ' + yHom + ' L' + (xH + aHom) + ' ' + yHom +
         ' L' + (xH + aCad) + ' ' + yCad + ' L' + (xH - aCad) + ' ' + yCad + ' Z"/>';
    s += '<path d="M' + (xH - aCad) + ' ' + yCad + ' L' + (xH - aPie) + ' ' + SUELO +
         ' L' + (xH - aPie * 0.15) + ' ' + SUELO + ' L' + (xH - aPie * 0.15) + ' ' + yCad + ' Z"/>';
    s += '<path d="M' + (xH + aCad) + ' ' + yCad + ' L' + (xH + aPie) + ' ' + SUELO +
         ' L' + (xH + aPie * 0.15) + ' ' + SUELO + ' L' + (xH + aPie * 0.15) + ' ' + yCad + ' Z"/>';
    s += '</g>';

    /* La planta: maceta, tronco y copa, en proporciones de planta de interior */
    var maceta = hP * 0.17, tronco = hP * 0.40;
    var copa = hP - maceta - tronco;
    var yMac = SUELO - maceta, yTro = yMac - tronco;
    s += '<path d="M' + (xP - hP * 0.105) + ' ' + yMac + ' L' + (xP + hP * 0.105) + ' ' + yMac +
         ' L' + (xP + hP * 0.078) + ' ' + SUELO + ' L' + (xP - hP * 0.078) + ' ' + SUELO + ' Z" fill="currentColor" opacity=".55"/>';
    s += '<line x1="' + xP + '" y1="' + yMac + '" x2="' + xP + '" y2="' + yTro + '" stroke="#534330" stroke-width="' + Math.max(1.6, hP * 0.016).toFixed(1) + '"/>';
    var hojas = [[-1, 0.9], [1, 0.9], [-1, 0.64], [1, 0.64], [0, 1.08]];
    for (var h = 0; h < hojas.length; h++) {
      var dir = hojas[h][0], f = hojas[h][1];
      var largo = copa * 0.92 * f;
      var x2 = xP + dir * largo * 0.72;
      var y2 = yTro - largo * (dir === 0 ? 1 : 0.62);
      s += '<path d="M' + xP + ' ' + yTro + ' Q' + (xP + dir * largo * 0.30) + ' ' + (y2 - largo * 0.16) +
           ' ' + x2 + ' ' + y2 + '" stroke="#818C7E" stroke-width="' + Math.max(3, hP * 0.05).toFixed(1) +
           '" fill="none" stroke-linecap="round"/>';
    }

    s += '<text x="' + xP + '" y="' + (SUELO + 20) + '" text-anchor="middle" font-family="Montserrat,sans-serif" font-size="11.5" font-weight="700" fill="currentColor">' + nombre + '</text>';
    s += '<text x="' + xH + '" y="' + (SUELO + 20) + '" text-anchor="middle" font-family="Montserrat,sans-serif" font-size="11.5" fill="currentColor" opacity=".6">Persona · 170 cm</text>';
    return s;
  }

  function cmDe(texto) {
    if (!texto) { return 0; }
    var m = String(texto).match(/(\d{2,3})\s*cm/i);
    return m ? parseInt(m[1], 10) : 0;
  }

  /* Los centímetros de la medida marcada ahora mismo. 0 si la variante no
     lleva cm en el nombre («Variegata», «Hojas Verdes»). */
  function cmSeleccionado() {
    var sel = seleccionActual();
    for (var i = 0; i < sel.length; i++) {
      var cm = cmDe(sel[i]);
      if (cm) { return cm; }
    }
    return 0;
  }

  /* La burbuja de la altura la pinta Liquid con la variante que venía de
     serie, y el tema NO vuelve a pintar este bloque al cambiar de medida:
     se quedaba clavada en «122 cm» con la de 182 marcada. Se refresca aquí,
     igual que los precios del selector. */
  function actualizarAltura() {
    var caja = document.querySelector('.product-details [data-bv-alto] b');
    if (!caja) { return; }
    var cm = cmSeleccionado();
    if (!cm) { return; }
    var txt = cm + ' cm';
    if (caja.textContent !== txt) { caja.textContent = txt; }
  }

  function pintarEscala() {
    var caja = document.querySelector('[data-bv-escala]');
    if (!caja) { return; }
    var svg = caja.querySelector('.bv-escala__cuerpo svg');
    if (!svg) { return; }

    var cm = cmSeleccionado();
    if (!cm) { cm = parseInt(caja.getAttribute('data-bv-escala'), 10) || 0; }
    if (!cm) { caja.hidden = true; return; }

    /* Con una sola medida, data-max es esa misma medida. La persona mide 170,
       así que la referencia nunca puede ser menor: si lo fuera, la persona
       saldría más alta que el propio tope de la escala y se saldría del marco. */
    var maxCm = parseInt(caja.getAttribute('data-max'), 10) || 0;
    if (maxCm < cm) { maxCm = cm; }
    if (maxCm < 170) { maxCm = 170; }
    caja.hidden = false;
    svg.innerHTML = dibujo(cm, maxCm, (caja.getAttribute('data-nombre') || 'Esta planta') + ' · ' + cm + ' cm');
    svg.setAttribute('aria-label', 'Comparación de tamaño: ' + cm + ' centímetros de alto frente a una persona de 170 centímetros.');
  }

  /* ---------------------------------------------------------------- */
  /* 3 · Fecha de entrega — mismo criterio que la ficha de la Cápsula  */
  /* ---------------------------------------------------------------- */

  function fechaEntrega() {
    var aviso = document.querySelector('[data-bv-entrega]');
    var texto = document.querySelector('[data-bv-entrega-txt]');
    if (!aviso || !texto) { return; }
    try {
      var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
      var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
        'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

      /* Criterio (11 oct 2026, de Héctor): el pedido que entra antes de la hora de corte se prepara y sale
         ese mismo día; el que entra después, el siguiente día que trabaja el taller. En Barcelona y
         alrededores llega el mismo día que sale («cerca» = 0 días de reparto); en el resto de la
         Península, al día siguiente de reparto («lejos» = 1). */
      var corte = parseInt(aviso.getAttribute('data-corte'), 10);
      var cerca = parseInt(aviso.getAttribute('data-cerca'), 10);
      var lejos = parseInt(aviso.getAttribute('data-lejos'), 10);
      var sabado = aviso.getAttribute('data-sabado') === 'true';
      if (isNaN(corte)) { corte = 12; }
      if (isNaN(cerca)) { cerca = 0; }
      if (isNaN(lejos)) { lejos = 1; }
      if (lejos < cerca) { lejos = cerca; }

      var festivos = {};
      var lista = (aviso.getAttribute('data-festivos') || '').split(',');
      for (var k = 0; k < lista.length; k++) {
        var clave = lista[k].replace(/\s/g, '');
        if (clave) { festivos[clave] = true; }
      }
      function esFestivo(f) {
        var mes = f.getMonth() + 1, dia = f.getDate();
        var t = f.getFullYear() + '-' + (mes < 10 ? '0' + mes : mes) + '-' + (dia < 10 ? '0' + dia : dia);
        return festivos[t] === true;
      }
      function soloDia(f) { return new Date(f.getFullYear(), f.getMonth(), f.getDate()); }
      function trabajaTaller(f) {
        var d = f.getDay();
        if (d === 0 || d === 6) { return false; }
        return !esFestivo(f);
      }
      function hayReparto(f) {
        var d = f.getDay();
        if (d === 0) { return false; }
        if (d === 6 && !sabado) { return false; }
        return !esFestivo(f);
      }
      function sumaReparto(desde, cuantos) {
        var x = new Date(desde.getTime()), puestos = 0;
        while (puestos < cuantos) {
          x.setDate(x.getDate() + 1);
          if (hayReparto(x)) { puestos += 1; }
        }
        return x;
      }
      function bonito(f) { return DIAS[f.getDay()] + ' ' + f.getDate() + ' de ' + MESES[f.getMonth()]; }
      function corto(f) { return DIAS[f.getDay()] + ' ' + f.getDate(); }
      function mismo(a, b) { return a.getTime() === b.getTime(); }
      function horaCorte() { return (corte < 10 ? '0' + corte : corte) + ':00'; }

      var ahora = new Date();
      var hoy = soloDia(ahora);
      var manana = new Date(hoy.getTime());
      manana.setDate(manana.getDate() + 1);

      var saleHoy = trabajaTaller(hoy) && ahora.getHours() < corte;
      var sale = new Date(hoy.getTime());
      if (!saleHoy) {
        do { sale.setDate(sale.getDate() + 1); } while (!trabajaTaller(sale));
      }
      var llegaCerca = sumaReparto(sale, cerca);
      var llegaLejos = sumaReparto(sale, lejos);

      /* Cuándo sale */
      var t;
      if (saleHoy) {
        t = 'Pídelo antes de las ' + horaCorte() + ' y sale hoy del taller.';
      } else if (mismo(sale, manana)) {
        t = 'Sale del taller mañana, ' + corto(sale) + '.';
      } else {
        t = 'Sale del taller el ' + bonito(sale) + '.';
      }
      /* Cuándo llega: cerca (Barcelona y alrededores) y lejos (resto de la Península) */
      var cercaTxt, lejosTxt;
      if (mismo(llegaCerca, hoy)) { cercaTxt = 'hoy mismo'; }
      else if (mismo(llegaCerca, manana)) { cercaTxt = 'mañana mismo'; }
      else if (mismo(llegaCerca, sale)) { cercaTxt = 'ese mismo ' + DIAS[llegaCerca.getDay()]; }
      else { cercaTxt = 'el ' + corto(llegaCerca); }
      if (mismo(llegaLejos, manana)) { lejosTxt = 'mañana, ' + corto(llegaLejos) + ','; }
      else { lejosTxt = 'el ' + bonito(llegaLejos); }
      if (mismo(llegaCerca, llegaLejos)) {
        t += ' Te llega ' + cercaTxt + ' en toda la Península.';
      } else {
        t += ' Te llega ' + cercaTxt + ' en Barcelona y alrededores; ' + lejosTxt + ' en el resto de la Península.';
      }
      /* Solo se escribe si cambia: escribir lo mismo también cuenta como
         mutación, y con el observador mirando sería un bucle sin fin. */
      if (texto.textContent !== t) { texto.textContent = t; }
    } catch (e) {
      /* se queda el texto de respaldo que ya viene escrito */
    }
  }

  /* ---------------------------------------------------------------- */
  /* Arranque y vigilancia del repintado                               */
  /* ---------------------------------------------------------------- */

  var ojo = null;
  var zona = null;
  var AJUSTES = { childList: true, subtree: true };
  var pendiente = false;

  /* Todo lo que añadimos provoca mutaciones, y el observador volvería a
     dispararse con ellas: sería una pescadilla. Se corta desconectando el
     observador mientras trabajamos y vaciando su cola antes de volver a
     escuchar (takeRecords), que es la forma fiable de hacerlo. */
  function repasar() {
    if (pendiente) { return; }
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      if (ojo) { ojo.disconnect(); }
      try {
        mejorarSelector();
        actualizarAltura();
        pintarEscala();
        fechaEntrega();
      } catch (e) {
        /* una ficha rara no debe tumbar la página */
      }
      if (ojo && zona) {
        ojo.takeRecords();
        ojo.observe(zona, AJUSTES);
      }
    });
  }

  function arrancar() {
    /* Se vigila el contenedor principal, no .product-details: si el tema
       llegara a sustituir esa columna entera, el observador se quedaría
       mirando un nodo ya desenganchado. Todo lo que escribe va dentro de
       repasar(), con el observador apagado; nada se escribe desde el propio
       aviso del observador. */
    zona = document.getElementById('MainContent') || document.body;

    if ('MutationObserver' in window) {
      ojo = new MutationObserver(function () { repasar(); });
      ojo.observe(zona, AJUSTES);
    }

    repasar();

    document.addEventListener('change', corregirCombinacion, true);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') { repasar(); }
    }, true);

    window.bvPro = { repasar: repasar };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();